module.exports = __webpack_public_path__ + "static/SeanRyan_Resume-7b510fbf41fcbc7bca6690489dfa9a70.pdf";